const angular = require('angular');

/**
 * Manage Views (Add, Edit (View Name), Remove)
 *
 * @export
 * @class ManageViewComponent
 */
export class ManageViewComponent {
  /**
   *
   *
   * @type {*}
   * @memberOf ManageViewComponent
   */
  views: any; //HTML element models
  /**
   *
   *
   * @type {*}
   * @memberOf ManageViewComponent
   */
  store: any; //Localstorage instance
  /**
   *
   *
   * @type {string}
   * @memberOf ManageViewComponent
   */
  viewName: string;
  /**
   *
   *
   * @type {*}
   * @memberOf ManageViewComponent
   */
  selectedView: any;
  /**
   *
   *
   *
   * @memberOf ManageViewComponent
   */
  defaultView = {
    editing: false,
    controls: {
      'A': []
    },
    viewName: ''
  };

  availableViews: Array<any>;
  $uibModal: any;
  $document: any;
  Util: any;
  $rootScope: any;
  $scope: any;
  ngNotification: any;
  $translate: any;

  /**
   * Creates an instance of ManageViewComponent.
   *
   * @param {any} localStorage
   *
   * @memberOf ManageViewComponent
   */
  constructor(localStorage, $uibModal, $document, Util, $rootScope, Notification, $translate, $scope) {
    this.$document = $document;
    this.$uibModal = $uibModal;
    this.Util = Util;
    this.store = localStorage;
    this.views = this.store.get('views');
    this.viewName = '';
    this.selectedView = this.store.get('selectedView');
    this.availableViews = this.Util.getViewNames();
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.ngNotification = Notification;
    this.$translate = $translate;
  }
  /**
   * To add new view.
   *
   * @param {*} keyEvent
   * @param {*} form
   * @returns {void}
   *
   * @memberOf ManageViewComponent
   */
  addView(keyEvent: any, form: any): void {
    this.clearValidationErrors(form, undefined);

    if (keyEvent && keyEvent.which != 13) {
      return;
    }

    if (!this.viewName) {
      form["viewName"].$error.required = true;
      return;
    }

    if (this.views[this.viewName]) {
      form["viewName"].$error.sameViewNameValidation = true;
      return;
    }

    this.views[this.viewName] = angular.copy(this.defaultView);
    this.views[this.viewName].viewName = this.viewName;
    this.viewName = '';
  }
  /**
   * To update selected view name.
   *
   * @param {string} key
   * @param {*} value
   * @param {*} form
   * @param {string} index
   * @param {*} keyEvent
   * @returns {void}
   *
   * @memberOf ManageViewComponent
   */
  updateViewName(key: string, value: any, form: any, index: string, keyEvent: any): void {
    this.clearValidationErrors(form, index);

    if (keyEvent && keyEvent.which != 13) {
      return;
    }

    if (!value.key) {
      form["viewName" + index].$error.required = true;
      return;
    }

    if (key == value.key) {
      this.views[value.key].editing = false;
      return;
    }

    if (this.views[value.key]) {
      form["viewName" + index].$error.sameViewNameValidation = true;
      return;
    }

    let temp = angular.copy(this.views[key]);
    delete this.views[key];
    this.views[value.key] = temp;
    this.views[value.key].editing = false;
    delete this.views[value.key].key;
    this.selectedView.view = this.views[value.key];
  }
  /**
   * To remove selected view.
   *
   * @param {string} key
   *
   * @memberOf ManageViewComponent
   */
  deleteView(key: string) : void{
    this.ngNotification.warning({
      message: 'warning.before.remove.view', positionX: 'center', replaceMessage: true, templateUrl: "warning_before_remove_view.html", scope: this.$scope
    });
  }

  removeView(key: any): void {
    key = key.viewName;
    let allViews = Object.keys(this.views);
    let viewControlData;
    let originalControl = [];
    
    if (Object.keys(this.views).length > 0 ) {
      // Original control form the deleting view.
      for (let i = 0; i < this.views[key].controls.A.length; i++) {
        // Repeating Table, Table, Button and Image
        if ((this.views[key].controls.A[i].type == "RepeatingTable" && !this.views[key].controls.A[i].hasOwnProperty("copiedFrom") && 
        !this.views[key].controls.A[i].hasOwnProperty("pasteAsCalculatedFrom") && 
        !this.views[key].controls.A[i].hasOwnProperty("derivedFromFieldName")) || 
        ((this.views[key].controls.A[i].type == "Table" || this.views[key].controls.A[i].type == "Button" || this.views[key].controls.A[i].type == "SiteLocationButton" || this.views[key].controls.A[i].type == "Image") && 
        (!this.views[key].controls.A[i].hasOwnProperty("copiedFrom") && !this.views[key].controls.A[i].hasOwnProperty("pasteAsCalculatedFrom")))) {
          viewControlData = angular.copy(this.views[key].controls.A[i]);
          originalControl.push(viewControlData);
        }
        // Layout, Display Field and Section
        else if ((this.views[key].controls.A[i].type == "Label" || this.views[key].controls.A[i].type == "Layout" || this.views[key].controls.A[i].type == "Display field") && 
        (!this.views[key].controls.A[i].hasOwnProperty("copiedFrom") && !this.views[key].controls.A[i].hasOwnProperty("forceToReadOnly") && !this.views[key].controls.A[i].hasOwnProperty("pasteAsCalculatedFrom"))){
          viewControlData = angular.copy(this.views[key].controls.A[i]);
          originalControl.push(viewControlData);
        }      
        else if (!this.views[key].controls.A[i].hasOwnProperty("copiedFrom") && this.views[key].controls.A[i].hasOwnProperty("pasteAsCalculated") != true && 
        !this.views[key].controls.A[i].hasOwnProperty("pasteAsCalculatedFrom") && !this.views[key].controls.A[i].hasOwnProperty("derivedFromFieldName") && this.views[key].controls.A[i].type != "Line") {
            viewControlData = angular.copy(this.views[key].controls.A[i]);
            originalControl.push(viewControlData);
        } 
      }
      // Logic to check all the view and find the Paste type controls and delete them accordingly.
      if (originalControl.length) {
        for (let j = 0; j < allViews.length; j++) {
          if(allViews[j] != this.views[key].viewName){
            let currentViewControlLength = this.views[allViews[j]].controls.A.length;
            
            for (let a = 0; a < originalControl.length; a++) {
              for (let k = 0; k < currentViewControlLength; k++) {
                
                if (this.views[allViews[j]].controls.A.length > 0 && this.views[allViews[j]].controls.A[k]) {
                  // For Paste as ReadOnly Controls.
                  if (this.views[allViews[j]].controls.A[k].copiedFrom && originalControl[a].properties.Basic["Field Name"] && this.views[allViews[j]].controls.A[k].copiedFrom == originalControl[a].properties.Basic["Field Name"].selectedValue) {
                    this.views[allViews[j]].controls.A.splice(k, 1);
                    k--;
                  }
                  // For Paste as calculated controls.
                  else if (this.views[allViews[j]].controls.A[k].pasteAsCalculated && originalControl[a].properties.Basic["Field Name"] && 
                  this.views[allViews[j]].controls.A[k].pasteAsCalculatedFrom == originalControl[a].properties.Basic["Field Name"].selectedValue && this.views[allViews[j]].controls.A[k].type == "Display field") {
                    this.views[allViews[j]].controls.A.splice(k, 1);
                    k--;
                  }
                  // For Paste as calculated controls old forms.
                  else if (!this.views[allViews[j]].controls.A[k].hasOwnProperty("pasteAsCalculatedFrom") && this.views[allViews[j]].controls.A[k].pasteAsCalculated && originalControl[a].properties.Basic["Data Field Name"] && 
                  this.views[allViews[j]].controls.A[k].properties.Basic.DSName.selectedValue == originalControl[a].properties.Basic["Data Field Name"].selectedValue && 
                  this.views[allViews[j]].controls.A[k].type == "Display field") {
                    this.views[allViews[j]].controls.A.splice(k, 1);
                    k--;
                  }
                  // For Paste as ReadOnly Layout
                  else if (this.views[allViews[j]].controls.A[k].copiedFrom && originalControl[a].properties.Basic["Field Name"] && 
                  this.views[allViews[j]].controls.A[k].copiedFrom == originalControl[a].properties.Basic["Field Name"].selectedValue) {
                    this.views[allViews[j]].controls.A.splice(k, 1);
                    k--;
                  }
                  // For Paste as calculated Section and Layout
                  else if (this.views[allViews[j]].controls.A[k].pasteAsCalculatedFrom && originalControl[a].properties.Basic["Field Name"] && 
                  this.views[allViews[j]].controls.A[k].pasteAsCalculatedFrom == originalControl[a].properties.Basic["Field Name"].selectedValue) {
                    this.views[allViews[j]].controls.A.splice(k, 1);
                    k--;
                  }
                  // For Paste as readOnly for the HyperLink.
                  else if (this.views[allViews[j]].controls.A[k].type == "Hyperlink" && this.views[allViews[j]].controls.A[k].hasOwnProperty("copiedFrom") &&
                  !this.views[allViews[j]].controls.A[k].hasOwnProperty("pasteAsCalculatedFrom") && originalControl[a].properties.Basic["Field Name"] && this.views[allViews[j]].controls.A[k].properties.Basic["Field Name"] &&
                  this.views[allViews[j]].controls.A[k].properties.Basic["Field Name"].selectedValue == originalControl[a].properties.Basic["Field Name"].selectedValue) {
                    this.views[allViews[j]].controls.A.splice(k, 1);
                    k--;
                  }
                  // For Repeating Table
                  else if (this.views[allViews[j]].controls.A[k].type == "RepeatingTable"){
                    // Repeating table Paste as ReadOnly. [ if control having copiedFrom && copiedFromRepeatingTable properties then its paste as ReadOnly control]
                    if ((this.views[allViews[j]].controls.A[k].copiedFrom) &&
                      (this.views[allViews[j]].controls.A[k].properties.Basic["Field Name"].selectedValue == originalControl[a].properties.Basic["Field Name"].selectedValue)){
                      this.views[allViews[j]].controls.A.splice(k, 1);
                      k--;
                    }
                    // Repeating table Paste as calculated.
                    else if (this.views[allViews[j]].controls.A[k].derivedFromFieldName == originalControl[a].properties.Basic["Field Name"].selectedValue && 
                    this.views[allViews[j]].controls.A[k].properties.Basic.DSName.selectedValue == originalControl[a].properties.Basic["Field Name"].selectedValue){
                      this.views[allViews[j]].controls.A.splice(k, 1);
                      k--;
                    }
                    // Repeating table Paste Only.
                    // Remove the copiedFromRepeatingTable property from Paste RT as Original RT control deleted so the Paste RT should not contain the property.
                    else if (this.views[allViews[j]].controls.A[k].copiedFromRepeatingTable && 
                      this.views[allViews[j]].controls.A[k].properties.Basic["Field Name"].selectedValue == originalControl[a].properties.Basic["Field Name"].selectedValue) {
                      delete this.views[allViews[j]].controls.A[k].copiedFromRepeatingTable;
                    }
                  }
                   // inlineAssoc control Paste Only.
                    // Remove the copiedFromInlieAssoc property from Paste inlineAssoc as Original inlineAssoc control deleted so the Paste inlineAssoc should not contain the property.
                    else if (this.views[allViews[j]].controls.A[k].copiedFromInlieAssoc && 
                      this.views[allViews[j]].controls.A[k].properties.Basic["Field Name"].selectedValue == originalControl[a].properties.Basic["Field Name"].selectedValue) {
                      delete this.views[allViews[j]].controls.A[k].copiedFromInlieAssoc;
                    }
                  // Controls like Table, Hyperlink, Button, Image
                  else if ((this.views[allViews[j]].controls.A[k].type == "Table" || this.views[allViews[j]].controls.A[k].type == "Hyperlink" || this.views[allViews[j]].controls.A[k].type == "Button" || this.views[allViews[j]].controls.A[k].type == "Image")){
                    // For Paste as ReadOnly Controls.
                    if (this.views[allViews[j]].controls.A[k].copiedFrom && originalControl[a].properties.Basic["Field Name"] && this.views[allViews[j]].controls.A[k].copiedFrom == originalControl[a].properties.Basic["Field Name"].selectedValue) {
                      this.views[allViews[j]].controls.A.splice(k, 1);
                      k--;
                    }
                    // For Table as Paste as calculated.
                    else if(_.get(this.views[allViews[j]].controls.A[k], 'data[0][0].elems[0][0]') && _.get(originalControl[a], 'data[0][0].elems[0][0].properties.Basic["Data Field Name"]') && this.views[allViews[j]].controls.A[k].data[0][0].elems[0][0].derivedFromFieldName == originalControl[a].data[0][0].elems[0][0].properties.Basic["Data Field Name"].selectedValue){
                      let controlMatch = false;
                      for (let y = 0; y < this.views[allViews[j]].controls.A[k].data.length; y++) {
                        for (let z = 0; z < this.views[allViews[j]].controls.A[k].data[y].length; z++) {
                          if(this.views[allViews[j]].controls.A[k].data[y][z].elems[0][0] && this.views[allViews[j]].controls.A[k].data[y][z].elems[0][0].derivedFromFieldName == originalControl[a].data[y][z].elems[0][0].properties.Basic["Data Field Name"].selectedValue){
                            controlMatch = true;
                          } else {
                            controlMatch = false;
                            break;
                          }
                        }
                        if (controlMatch == false) {
                          break;
                        }
                      }
                      if(controlMatch == true){
                        this.views[allViews[j]].controls.A.splice(k, 1);
                        k--;
                      }
                    }
                  }
                  // Controls like Layout
                  else if (this.views[allViews[j]].controls.A[k].type == "Layout"){
                    // For Paste as ReadOnly Controls.
                    if (this.views[allViews[j]].controls.A[k].copiedFrom && originalControl[a].properties.Basic["Field Name"] && this.views[allViews[j]].controls.A[k].copiedFrom == originalControl[a].properties.Basic["Field Name"].selectedValue) {
                      this.views[allViews[j]].controls.A.splice(k, 1);
                      k--;
                    }
                    // For Layout as Paste as calculated.
                    else if(_.get(this.views[allViews[j]].controls.A[k], 'data[0].elems[0][0]') && _.get(originalControl[a], 'data[0].elems[0][0].properties.Basic["Data Field Name"]') && 
                    !this.views[allViews[j]].controls.A[k].hasOwnProperty("pasteAsCalculatedFrom") &&
                    this.views[allViews[j]].controls.A[k].data[0].elems[0][0].derivedFromFieldName == originalControl[a].data[0].elems[0][0].properties.Basic["Data Field Name"].selectedValue){
                      for (let y = 0; y < this.views[allViews[j]].controls.A[k].data.length; y++) {
                        if(this.views[allViews[j]].controls.A[k].data[y].elems[0][0] && 
                          this.views[allViews[j]].controls.A[k].data[y].elems[0][0].derivedFromFieldName == originalControl[a].data[y].elems[0][0].properties.Basic["Data Field Name"].selectedValue){
                          this.views[allViews[j]].controls.A[k].data[y].elems[0] = [];
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    delete this.views[key];
    if (Object.keys(this.views).length == 0) {
      let defaultView = angular.copy(this.defaultView)
      defaultView.viewName = 'ORI_VIEW';
      this.views['ORI_VIEW'] = defaultView;
      this.Util.addSubjectField(this.views.ORI_VIEW);
    };

    this.selectedView.view = this.views[Object.keys(this.views)[0]];
  }
  /**
   * To select view.
   *
   * @param {string} key
   *
   * @memberOf ManageViewComponent
   */
  selectView(key: string): void {
    this.selectedView.view = this.views[key];
  }
  /**
   * To clear view name validation for selected view.
   *
   * @param {*} form
   * @param {string} [index='']
   *
   * @memberOf ManageViewComponent
   */
  clearValidationErrors(form: any, index: string = ''): void {
    form["viewName" + index].$error.sameViewNameValidation = false;
    form["viewName" + index].$error.required = false;
  }

  getLanguageSpecificViewName(viewName) {
    return this.Util.getLanguageSpecificViewName(viewName);
  }

  isCustomView(viewName) {
    return !this.availableViews.filter(function (value) {
      return value.value == viewName;
    }).length;
  }
  openAddView(viewName = '', update = false) {
    let selectedView = this.availableViews.filter(function (value) {
      return value.value == viewName;
    });
    let viewFound = selectedView.length ? selectedView[0] : viewName;
    let self = this;
    let modalInstance = this.$uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'addView.html',
      backdrop: 'static',
      keyboard: false,
      controllerAs: '$ctrl',
      appendTo: angular.element(self.$document[0].querySelector('.manager-view')),
      controller: function () {
        this.viewExist = false;
        this.Value = viewFound;
        this.availableViews = [];

        let currentAddedViews = [];
        for (let view in self.views) {
          let selectedView = self.availableViews.filter(function (value) {
            return value.value == view;
          });
          if (selectedView.length) {
            if (viewName.toLowerCase() != selectedView[0].value.toLowerCase()) {
              currentAddedViews.push(selectedView[0].key.toLowerCase());
              currentAddedViews.push(selectedView[0].value.toLowerCase());
            }
          } else {
            if (viewName.toLowerCase() != view.toLowerCase()) {
              currentAddedViews.push(view.toLowerCase());
            }
          }
        }

        if (self.availableViews.length) {
          for (let i = 0; i < self.availableViews.length; i++) {
            let view = self.availableViews[i];
            if (currentAddedViews.indexOf(view.value.toLowerCase()) == -1) {
              this.availableViews.push(view);
            }
          }
        }

        this.save = function () {
          let updatedViewName = this.Value;
          if (angular.isObject(this.Value)) {
            updatedViewName = this.Value.value;
          } else {
            let selectedView = self.availableViews.filter(function (value) {
              return value.key.toLowerCase() == updatedViewName.toLowerCase();
            });
            if (selectedView.length) {
              updatedViewName = selectedView[0].value;
            } else {
              let validText = self.Util.isValidXMLTagName(updatedViewName);
              if (!validText) {
                let msg = self.$translate.instant('field.name.validation');
                self.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
                return;
              }
            }
          }

          if (currentAddedViews.indexOf(updatedViewName.toLowerCase()) != -1) {
            this.viewExist = true;
            return;
          }
          if (update) {
            let temp = angular.copy(self.views[viewName]);
            delete self.views[viewName];
            self.views[updatedViewName] = temp;
            self.views[updatedViewName].editing = false;
            self.views[updatedViewName].viewName = updatedViewName;
            self.selectedView.view = self.views[updatedViewName];
          } else {
            let defaultView = angular.copy(self.defaultView);
            defaultView.viewName = updatedViewName;
            if (updatedViewName) {
              self.views[updatedViewName] = defaultView;
              updatedViewName == "ORI_VIEW" && self.Util.addSubjectField(defaultView);
            }
          }
          this.cancel();
          self.$rootScope.$broadcast('designViewAdded', { viewName: updatedViewName });
        };
        this.cancel = function () {
          modalInstance.dismiss('cancel');
        };
        this.isObject = angular.isObject;
      }
    });
  }

  viewChangeHander() {
    this.$rootScope.$broadcast('onViewChange');
  }

}

export default angular.module('directives.manageview', [])
  .component('manageview', {
    template: require('./manage-view.html'),
    controller: ManageViewComponent,
    bindings: {
      active: '@',
      onToolbarClick: '@'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/manage-view/manage-view.component.ts